import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-version',
  templateUrl: './dashboard-version.component.html',
  styleUrls: ['./dashboard-version.component.scss'],
})
export class DashboardVersionComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
